import { render, staticRenderFns } from "./setSecondaryPlots.vue?vue&type=template&id=5c762763&scoped=true"
import script from "./setSecondaryPlots.vue?vue&type=script&lang=js"
export * from "./setSecondaryPlots.vue?vue&type=script&lang=js"
import style0 from "./setSecondaryPlots.vue?vue&type=style&index=0&id=5c762763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c762763",
  null
  
)

export default component.exports